//import sound effect
import ALARM from './sounds/alarmClock.wav';

//Settings to change default state settings
const SETTINGS = {
    breakL:5,
    sessionL:'25',
    currentS: '00',
    speedOfTimer: 1000
};

const DEFAULT_STATE = {
    displayString:'Session',  //string for the display, indicates if a session or break is active
    breakL:SETTINGS.breakL,   //length of a break
    sessionL:SETTINGS.sessionL,//length of a session
    currentM:SETTINGS.sessionL,//Current minutes left for the timer
    currentS:SETTINGS.currentS,//Current seconds left for the timer
    timerActive:false,         //Current Status of the timer
    speedOfTimer:SETTINGS.speedOfTimer, //Speed of the timer in milliseconds
    timerID:null,               //Current Timer ID
    sessionTimerActive:true,           //Set to true to indicate that the timer has reached 00:00
    audioID: 'beep'             //ID of the audio tag
};

const mapStateToProps = (state) => {
    return Object.assign({},state);
};

//actions
const ACTIONS = {
    START_STOP_PRESSED:'START_STOP_PRESSED',
    TIMER_ACTIVE:'TIMER_ACTIVE',
    TIMER_ID: 'TIMER_ID',
    SESSION_L: 'SESSION_L',
    BREAK_L: 'BREAK_L',
    INCREMENT_TIMER:'INCREMENT_TIMER',
    DECREMENT_TIMER:'DECREMENT_TIMER',
    RESET:'RESET'
};

//action creators
const ACTION_CREATORS =  {
    startStop: () =>{
        return {
            type:ACTIONS.START_STOP_PRESSED
        };
    },
    timer_set_active: () =>{
        return {
            type:ACTIONS.TIMER_ACTIVE
        };
    },
    set_timer_id: (timerID) => {
        return{
            type:ACTIONS.TIMER_ID,
            timerID
        };
    },
    set_session_length: (adjustTimer) => {
        return {
            type:ACTIONS.SESSION_L,
            adjustTimer
        };
    },
    set_break_length: (adjustTimer) => {
        return {
            type:ACTIONS.BREAK_L,
            adjustTimer
        };
    },
    resetEverything:()=>{
        return{
            type:ACTIONS.RESET
        }
    }
    
};

const CONSTANTS = {
    DEFAULT_STATE:DEFAULT_STATE,
    MAP_STATE_TO_PROPS:mapStateToProps,
    ACTIONS:ACTIONS,
    ACTION_CREATORS:ACTION_CREATORS,
    ALARM:ALARM
};

export default CONSTANTS;